import type { FaireProductEntity } from "../../entity_types/product";

export const p_ruda6ynq5d: FaireProductEntity = {
  token: "p_ruda6ynq5d",
  type: "product",
  name: "Feel Better De-Stress Ball, Jello",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl:
    "https://cdn.faire.com/fastly/1bdaaabda827f5693913292e22badd2ee1fd85fb61255ab23b309a57deec5a10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28d29114e8854b12c2e0169294e18b92aa92c48c433c88ec8143d432e1bc214c.jpeg",
    "https://cdn.faire.com/fastly/a5f1793e1602ec245ebf0a40c3f99884362d8808928f4a29d3705671d734df51.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because there’s nothing stressful about jello. This ban.do de-stress ball is made of slow-rising polyurethane foam, which means no matter how tight you squeeze, it always bounces back to its original shape. Soft, squishy, and oddly satisfying, it’s the perfect way to keep calm and wiggle the stress away.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Jello-inspired design made of slow-rising polyurethane foam\n• Returns to its original shape after every squeeze\n• Ideal for stress relief, fidgeting, or mindful breaks\n• Compact and lightweight—great for home, office, or travel\n• Designed in ban.do’s signature colorful and playful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and lifestyle boutiques\n• Wellness and novelty retailers\n• Students, professionals, and fidget lovers\n• Wholesale buyers seeking fun, functional stress-relief accessories",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:47.358Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
